




































































































































































































































import Component from 'vue-class-component'
import Vue from 'vue'
import VueMultiselect from 'vue-multiselect'
import RespondecoCategories from '../../../shared/components/respondeco-categories.vue'
import { MetaService } from '@/shared/services/meta-service'
import { OrganisationsModule } from '@/business/organisation/store/organisations-module'
import { Injector } from '@/config/dependency-injection'
import { OrganisationState } from '@/business/organisation/store/organisation-state'
import { LoaderHelper } from '@/shared/services/loader-helper'
import { UPDATE_ORGANISATION } from '@/business/organisation/store/types'
import { NotificationService } from '@/shared/services/notification-service'
import { ExtendedBlob } from '@/shared/models/extended-blob'
import { loggerFor } from '@/shared/utils/logger'
import RespondecoForm from '@/shared/components/respondeco-form.vue'
import RespondecoValidationFeedback from '@/shared/components/respondeco-validation-feedback.vue'
import RespondecoTopBar from '@/main/respondeco-top-bar.vue'
import UnifyList from '@/shared/components/unify/unify-list.vue'
import UnifyListItem from '@/shared/components/unify/unify-list-item.vue'
import UnifyListItemLabel from '@/shared/components/unify/unify-list-item-label.vue'
import UnifyListItemContent from '@/shared/components/unify/unify-list-item-content.vue'
import UnifyFormInput from '@/shared/components/unify/unify-form-input.vue'
import UnifyTextarea from '@/shared/components/unify/unify-textarea.vue'
import UnifyFormToggle from '@/shared/components/unify/unify-form-toggle.vue'
import RespondecoImage from '@/shared/components/respondeco-image.vue'
import UnifyButton from '@/shared/components/unify/unify-button.vue'
import RespondecoTypedForm from '@/shared/components/respondeco-typed-form.vue'
import { TypedForm } from '@/shared/forms/typed-form'
import {
  OrganisationForm,
  organisationFormMapping,
} from '@/business/organisation/models/organisation-form'
import { Hooks } from '@/shared/interfaces/hooks'
import { organisationRequestResponseFormMapping } from '@/business/organisation/models/organisation-request-response-mapping'
import { OrganisationRequest, OrganisationResponse } from '@/api/generated'
import RespondecoResourceChooser from '@/shared/components/respondeco-resource-chooser.vue'
import RespondecoEditor from '@/shared/components/respondeco-editor.vue'
import RespondecoBlock from '@/shared/components/respondeco-block.vue'
import MultiselectClear from '@/shared/components/multiselect-clear.vue'
import RespondecoIcon from '@/shared/components/respondeco-icon.vue'
import RespondecoSaveBar from '@/shared/components/respondeco-save-bar.vue'
import { HomeService } from '@/business/home/home-service'

@Component({
  components: {
    RespondecoSaveBar,
    RespondecoIcon,
    MultiselectClear,
    RespondecoBlock,
    RespondecoEditor,
    RespondecoResourceChooser,
    RespondecoTypedForm,
    UnifyButton,
    RespondecoImage,
    UnifyFormToggle,
    UnifyTextarea,
    UnifyFormInput,
    UnifyListItemContent,
    UnifyListItemLabel,
    UnifyListItem,
    UnifyList,
    RespondecoValidationFeedback,
    RespondecoForm,
    RespondecoCategories,
    RespondecoTopBar,
    VueMultiselect,
  },
})
export default class OrganisationSettingsProfile extends Vue implements Hooks {
  public form!: TypedForm<OrganisationResponse, OrganisationForm>

  private homeService = Injector.get(HomeService)
  private loadingHelper = Injector.get(LoaderHelper)
  private metaService = Injector.get(MetaService)
  private notificationService = Injector.get(NotificationService)
  private organisationsModule = Injector.get(OrganisationsModule)

  private logger = loggerFor('OrganisationSettingsProfile')

  private requestResponseMapping = organisationRequestResponseFormMapping()

  private previewImage?: ExtendedBlob
  private unsaved = false
  private unwatch!: () => void

  get dirty() {
    return this.form.dirty || this.unsaved
  }

  get loading() {
    return this.loadingHelper.isLoading(UPDATE_ORGANISATION)
  }

  get lookupCategories() {
    return this.viewModel.lookup.categories.map(item => item.value)
  }

  get lookupOrganisationTypes() {
    return this.viewModel.lookup.organisationTypes.map(item => item.value)
  }

  get lookupSectors() {
    return this.viewModel.lookup.sectors.map(item => item.value)
  }

  get organisation() {
    return this.viewModel.organisation
  }

  get saving() {
    return this.loadingHelper.isLoading(UPDATE_ORGANISATION)
  }

  get viewModel() {
    return this.organisationsModule.organisationViewModel
  }

  public created() {
    this.initialise()

    this.unwatch = this.$store.watch(
      (state: OrganisationState) => state.organisationViewModel,
      () => {
        this.initialise()
      }
    )
  }

  public data() {
    return {
      form: new TypedForm(organisationFormMapping(), this),
    }
  }

  public destroyed() {
    this.unwatch()
  }

  public provide() {
    return {
      form: this.form.group(),
    }
  }

  public customCategoryLabel(option: string) {
    return this.$t('lookup.category.' + option)
  }

  public customSectorLabel(option: string) {
    return this.$t('lookup.sector.' + option)
  }

  public customTypeLabel(option: string) {
    return this.$t('lookup.organisation_type.' + option)
  }

  public initialise() {
    this.reset()

    this.metaService.updateDocumentTitle('organisation.settings.profile', {
      name: this.organisation.name,
    })
  }

  public reset() {
    this.form.reset(this.organisation)
  }

  public save() {
    const model: OrganisationRequest = this.requestResponseMapping.deserialize(
      this.form.serialize(this.organisation)
    )

    this.logger.info('Updating', model)

    if (model.id !== undefined) {
      this.organisationsModule
        .updateOrganisation({
          file: this.previewImage,
          organisation: model,
          organisationId: model.id,
        })
        .then(
          () => {
            this.homeService.konstanz$.markStale()
            this.notificationService.success('common.success')

            this.form.reset(this.organisation)
            this.unsaved = false
          },
          this.notificationService.errorHandler({
            409: 'organisation.failure_code.409',
          })
        )
    }
  }

  public validations() {
    return this.form.validations()
  }
}
